import { useRef } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { TSTFilterBar, TSTPagination, TSTTable } from "@impero-com/ui";

import {
    SimpleTestingProgram,
    SimpleTestingProgramListDto as TestingProgramListDto,
} from "api/generated/model";
import { getFilterModeConfig } from "utils/table/getFilterModeConfig";

import { useTestingProgramListTable } from "./useTestingProgramListTable";

interface TestingProgramListProps {
    data: TestingProgramListDto;
}
export function TestingProgramList({ data }: TestingProgramListProps) {
    const { t } = useTranslation();

    const { table, getFilterComponent, tableId } =
        useTestingProgramListTable(data);
    const tableElement = useRef<HTMLDivElement>(null);

    const modeConfig = getFilterModeConfig(t);

    return (
        <div>
            <TSTFilterBar<SimpleTestingProgram>
                table={table}
                tableId={tableId}
                addLabel={t("FilterBar_AddFilter")}
                globalSearchLabel={t("FilterBar_GlobalSearchPlaceholder")}
                getFilterCountLabel={(count) =>
                    t("FilterBar_FiltersApplied", { count })
                }
                rowCountLabel={t("FilterBar_RowCount", {
                    count: table.getPrePaginationRowModel().rows.length,
                })}
                hideFiltersLabel={t("FilterBar_HideFilters")}
                clearAllLabel={t("FilterBar_ClearAll")}
                getFilterComponent={getFilterComponent}
                modeConfig={modeConfig}
            />
            <TSTTable
                tableRef={tableElement}
                table={table}
                noResultsFallback={t("NoResults")}
                noSourceRowsFallback={t("NoResults")}
            />
            <TSTPagination
                table={table}
                pageLabel={t("Pagination_Page")}
                getRowCountLabel={(shown, count) =>
                    t("Pagination_RowCount", { shown, count })
                }
                getSinglePageRowCountLabel={(count) =>
                    t("Pagination_RowCountSinglePage", { count })
                }
                tableElement={tableElement}
            />
        </div>
    );
}
